import { Article } from '../types';

interface ArticleListProps {
  articles: Article[];
  selectedArticle: Article | null;
  onSelect: (article: Article) => void;
  onEdit: (article: Article) => void;
  onDelete: (id: string) => void;
}

export function ArticleList({
  articles,
  selectedArticle,
  onSelect,
  onEdit,
  onDelete,
}: ArticleListProps) {
  return (
    <div className="article-list">
      <h3>文章列表</h3>
      <ul>
        {articles.map((article) => (
          <li
            key={article.id}
            className={selectedArticle?.id === article.id ? 'active' : ''}
            onClick={() => onSelect(article)}
          >
            <span className="article-title">{article.title}</span>
            <div className="article-actions">
              <button
                className="btn-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(article);
                }}
                title="编辑"
              >
                ✏️
              </button>
              <button
                className="btn-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  if (confirm('确定要删除这篇文章吗？')) {
                    onDelete(article.id);
                  }
                }}
                title="删除"
              >
                🗑️
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
